<template>
  <div class="c-navigation-drawer__wrapper js-navigation-wrapper">
    <template v-if="!subscriber.isLogged">
      <ui-drawer-subscriber
        class="u-uppercase"
        @showProfiles="showProfiles"
      ></ui-drawer-subscriber>
      <div class="o-separator o-separator--horizontal o-separator--invert-color"></div>
    </template>
    <template v-for="(group, index) in menuItems">
      <template v-if="isItemVisible(group)">
        <template v-for="(item, id) in group.elements">
          <div
            v-if="item.isLogged ? subscriber.isLogged : true"
            :key="`${item.name}-${index}-${id}`"
            class="c-navigation-drawer__element"
          >
            <h2 v-if="isItemVisible(item)">
              <v-link
                :key="item.name"
                :to="item.url"
                :class="{ 'u-uppercase': item.uppercase }"
                class="o-typography--action o-typography--stateful c-navigation-drawer__item"
                target="_blank"
              >
                <v-icon :icon="item.icon"></v-icon>
                <span>{{ item.name }}</span>
              </v-link>
            </h2>
            <v-toggle
              v-if="item.toggle"
              v-model="kidsMode"
              class="u-mobile-only"
            ></v-toggle>
          </div>
        </template>
        <div
          v-if="index !== menuItems.length - 1"
          class="o-separator o-separator--horizontal"
        ></div>
      </template>
    </template>
    <template v-if="subscriber.isLogged">
      <div
        v-accessibility-focus="logout"
        class="o-typography--action c-navigation-drawer__item"
      >
        <i class="o-icon o-icon--log-out"></i>
        <span>{{ $t('common.signOut') }}</span>
      </div>
    </template>
    <template v-if="info.languages.length > 1">
      <div class="o-separator o-separator--horizontal"></div>
      <ui-drawer-language></ui-drawer-language>
    </template>
  </div>
</template>

<script>
  import { VIcon, VLink, VToggle } from '@/index/shared/components';
  import { RouteName } from '@/shared/enums';
  import { onboardingMixin } from '@/index/shared/mixins';
  import UiDrawerLanguage from './language.vue';
  import UiDrawerSubscriber from './subscriber.vue';

  export default {
    components: {
      UiDrawerLanguage,
      UiDrawerSubscriber,
      VIcon,
      VLink,
      VToggle,
    },
    enums: {
      RouteName,
    },
    mixins: [
      onboardingMixin,
    ],
    data() {
      return {
        menu: this.$services.resolve('menu'),
        subscriber: this.$services.resolve('subscriber'),
        info: this.$services.resolve('info'),
      };
    },
    computed: {
      menuItems() {
        if (this.subscriber.isKidsTheme) {
          return this.menu.data.mobileKids;
        }

        return this.menu.data.mobile;
      },
      kidsMode: {
        get() {
          return this.$storage.isKidsMode;
        },
        set(newValue) {
          this.subscriber.setKidsMode(newValue);
        },
      },
    },
    watch: {
      $route: 'close',
    },
    methods: {
      logout() {
        this.$spinner.show();
        this.subscriber.logout()
          .then(() => {
            this.$router.replace({ name: RouteName.HOME });
            this.close();
          }).catch(() => {});
      },
      close() {
        this.$emit('close');
      },
      isItemVisible(item) {
        if (this.isLightMenu) {
          return false;
        }

        return !item.isLogged || (item.isLogged && this.subscriber.isLogged);
      },
      showProfiles(options) {
        this.$emit('showProfiles', options);
      },
    },
  };
</script>
